export default {
    CREATE: "Создать",
    SAVE: "Сохранить",
    DUPLICATE: "Дублировать",
    CANCEL: "Отменить",
    BACK: "Назад",
    NAME: "Название",
    DESCRIPTION: "Описание",
    IMPORT_FILE: "Импортировать файл",
    IMPORT_TITLE: "Импорт",
    IMPORT_SAVE: "Сохранить",
    sizeMessage: (size) => `Размер файла не должен превышать ${size}`,
    fileExtensionMessage: (extensions) => `Тип файла должен быть ${extensions}`,
    uploadText: (size, extensions) => `Вы можете загрузить ${extensions}, не более ${size}`,
    DUPLICATE_IN_PROJECT: "Дублировать в проект",
    PROJECT: "Проект"
};
